module.exports = __webpack_public_path__ + "static/media/success.544baea1.svg";